// src/hooks/useBodyScrollLock.js
//
// Modal/bottom-sheet açıkken arka plan sayfasının kaymasını engeller
// ("scroll bleed" düzeltmesi). CreateSheet'teki kanıtlanmış desenin
// paylaşılan hook hali: body overflow kilidi + scroll pozisyonu korunur,
// iOS Safari için position:fixed tekniği kullanılır.
//
// Kullanım: useBodyScrollLock(isOpen)
// Birden çok modal üst üste açılırsa sayaçla yönetilir — son modal
// kapanana kadar kilit kalkmaz.

import { useEffect } from "react";

let lockCount = 0;
let savedScrollY = 0;

function lock() {
  lockCount += 1;
  if (lockCount > 1) return;
  savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
  const body = document.body;
  body.style.position = "fixed";
  body.style.top = `-${savedScrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";
  body.style.overflow = "hidden";
  body.style.overscrollBehavior = "none";
}

function unlock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0) return;
  const body = document.body;
  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  body.style.width = "";
  body.style.overflow = "";
  body.style.overscrollBehavior = "";
  window.scrollTo(0, savedScrollY);
}

/**
 * @param {boolean} active — modal açık mı
 */
// ⚠️ `boolean` YAZILMAZ: ölçüldü — CloseFriendsSheet ve FollowRequestsSheet
// buraya `boolean | undefined` geçiyor ve gövde `if (!active) return` ile
// bunu zaten karşılıyor. Daraltmak hatayı silmez, ÇAĞIRANLARA taşır.
export default function useBodyScrollLock(active: boolean | undefined) {
  useEffect(() => {
    if (!active) return undefined;
    lock();
    return () => unlock();
  }, [active]);
}
